// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class OrderGroup extends PFixFieldSet {
    get isAllowOTHTrading() {
        return this.GetValue(FieldsFactory.FIELD_ALLOW_OTH_TRADING);
    }
    set isAllowOTHTrading(value) {
        if (!isNullOrUndefined(value)) {
            this.SetField(FieldsFactory.FIELD_ALLOW_OTH_TRADING, value);
        }
    }
    constructor(pfixFieldSet) {
        super(FieldsFactory.ORDER_GROUP_NAME, null, pfixFieldSet);
    }
    getOrderId() {
        return this.GetValue(FieldsFactory.FIELD_ORDER_ID);
    }
    getClientOrderId() {
        return this.GetValue(FieldsFactory.FIELD_CLIENT_ORDER_ID);
    }
    setClientOrderId(orderId) {
        this.SetField(FieldsFactory.FIELD_CLIENT_ORDER_ID, orderId);
    }
    getOrderType() {
        const type = this.GetValue(FieldsFactory.FIELD_ORDER_TYPE);
        return type;
    }
    setOrderType(type) {
        this.SetField(FieldsFactory.FIELD_ORDER_TYPE, type);
    }
    getOperationType() {
        const type = this.GetValue(FieldsFactory.FIELD_OPERATION_TYPE);
        return type;
    }
    setOperationType(operationType) {
        this.SetField(FieldsFactory.FIELD_OPERATION_TYPE, operationType);
    }
    getInstrumentId() {
        return this.GetValue(FieldsFactory.FIELD_INSTRUMENT_ID);
    }
    setInstrumentId(id) {
        this.SetField(FieldsFactory.FIELD_INSTRUMENT_ID, id);
    }
    getInstrumentTradableID() {
        return this.GetValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
    }
    setInstrumentTradableID(id) {
        this.SetField(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, id);
    }
    getPrice() {
        return this.GetValue(FieldsFactory.FIELD_PRICE);
    }
    setPrice(price) {
        this.SetField(FieldsFactory.FIELD_PRICE, price);
    }
    getStopPrice() {
        return this.GetValue(FieldsFactory.FIELD_STOP_PRICE);
    }
    setStopPrice(stopPrice) {
        this.SetField(FieldsFactory.FIELD_STOP_PRICE, stopPrice);
    }
    getSLPrice() {
        return this.GetValue(FieldsFactory.FIELD_SL_PRICE);
    }
    getTPPrice() {
        return this.GetValue(FieldsFactory.FIELD_TP_PRICE);
    }
    // FIELD_SL_TR_OFFSET - для аналога стоплосса
    getTralingOffset2() {
        return this.GetValue(FieldsFactory.FIELD_SL_TR_OFFSET);
    }
    getAmount() {
        return this.GetValue(FieldsFactory.FIELD_AMOUNT);
    }
    setAmount(amount) {
        this.SetField(FieldsFactory.FIELD_AMOUNT, amount);
    }
    setCashOrderQty(cash) {
        this.SetField(FieldsFactory.FIELD_CASH_ORDER_QTY, cash);
    }
    getValidity() {
        const tif = this.GetValue(FieldsFactory.FIELD_VALIDITY);
        return tif;
    }
    setValidity(tif) {
        this.SetField(FieldsFactory.FIELD_VALIDITY, tif);
    }
    getExpDay() {
        return this.GetValue(FieldsFactory.FIELD_EXP_DAY);
    }
    getExpMonth() {
        return this.GetValue(FieldsFactory.FIELD_EXP_MONTH);
    }
    getExpYear() {
        return this.GetValue(FieldsFactory.FIELD_EXP_YEAR);
    }
    getAccountId() {
        return this.GetValue(FieldsFactory.FIELD_ACCOUNT_ID);
    }
    setAccountId(accountId) {
        this.SetField(FieldsFactory.FIELD_ACCOUNT_ID, accountId);
    }
    getProductType() {
        return this.GetValue(FieldsFactory.FIELD_PRODUCT_TYPE);
    }
    setProductType(productType) {
        this.SetField(FieldsFactory.FIELD_PRODUCT_TYPE, productType);
    }
    getRouteId() {
        return this.GetValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    setRouteId(routeId) {
        this.SetField(FieldsFactory.FIELD_ROUTE_ID, routeId);
    }
    getTIFExpireDate() {
        return this.GetValue(FieldsFactory.FIELD_EXPIRE_AT);
    }
    setTIFExpireDate(dt) {
        this.SetField(FieldsFactory.FIELD_EXPIRE_AT, dt);
    }
    setSLPrice(price) {
        this.SetField(FieldsFactory.FIELD_SL_PRICE, price);
    }
    setSLPriceType(priceType) {
        this.SetField(FieldsFactory.FIELD_SL_PRICE_TYPE, priceType);
    }
    setSLLimitPrice(price) {
        this.SetField(FieldsFactory.FIELD_SL_LIMIT_PRICE, price);
    }
    setTPPrice(price) {
        this.SetField(FieldsFactory.FIELD_TP_PRICE, price);
    }
    setTPPriceType(priceType) {
        this.SetField(FieldsFactory.FIELD_TP_PRICE_TYPE, priceType);
    }
    setTrailingOffset(offset) {
        this.SetField(FieldsFactory.FIELD_TR_OFFSET, offset);
    }
    setOpen(open) {
        this.SetField(FieldsFactory.FIELD_IS_OPEN, open);
    }
    setByBroker(isByBroker) {
        this.SetField(FieldsFactory.FIELD_IS_BY_BROKER, isByBroker);
    }
    setIsByStrategy(isByStrategy) {
        this.SetField(FieldsFactory.FIELD_IS_AUTOTRADE_ORDER, isByStrategy);
    }
    setBoundTo(id) {
        this.SetField(FieldsFactory.FIELD_BOUNDTOORDERID, id);
    }
    setOrderIdToLink(orderId) {
        this.SetField(FieldsFactory.FIELD_CLIENT_ORDER_ID_TO_LINK, orderId.toString());
    }
    setOrderLinkType(linkType) {
        this.SetField(FieldsFactory.FIELD_ORDER_LINK_TYPE, linkType);
    }
    setPlacedFrom(placedFrom) {
        this.SetField(FieldsFactory.FIELD_CLIENT_PANEL, placedFrom);
    }
    setDisclosedQty(disclosedQty) {
        this.SetField(FieldsFactory.FIELD_DISCLOSED_QUANTITY, disclosedQty);
    }
    setSLTriggerPrice(price) {
        this.SetField(FieldsFactory.FIELD_SL_TRIGGER_PRICE, price);
    }
    setTPTriggerPrice(price) {
        this.SetField(FieldsFactory.FIELD_TP_TRIGGER_PRICE, price);
    }
    setSLTPTriggerPrice(price) {
        this.SetField(FieldsFactory.FIELD_SL_TP_TRIGGER_PRICE, price);
    }
    setLeverage(leverageValue) {
        this.SetField(FieldsFactory.FIELD_LEVERAGE_SHORT, leverageValue);
    }
    setComment(comment) {
        this.SetField(FieldsFactory.FIELD_COMMENT, comment);
    }
    setUserComment(comment) {
        this.SetField(FieldsFactory.FIELD_USER_COMMENT, comment);
    }
}
